import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import { analyticsMiddleware } from 'vue-analytics';
import actions from './actions';
import modules from './modules';

Vue.use(Vuex);

const debug = (process.env.NODE_ENV !== 'production')
    && (process.env.NODE_ENV !== 'testing');

const store = new Vuex.Store({
    actions,
    modules,
    strict: debug,
    plugins: debug ? [createLogger()] : [analyticsMiddleware],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js